import { render, staticRenderFns } from "./EventLottery.vue?vue&type=template&id=9be58f48&scoped=true&"
import script from "./EventLottery.vue?vue&type=script&lang=js&"
export * from "./EventLottery.vue?vue&type=script&lang=js&"
import style0 from "./EventLottery.vue?vue&type=style&index=0&id=9be58f48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be58f48",
  null
  
)

export default component.exports